var _rect, _polygon, _polygon2, _polygon3, _polygon4, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    fill: "#012169"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 2.8,0 24,13.4 24,16 21.2,16 0,2.6",
    fill: "#FFFFFF"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "24,0 21.2,0 0,13.4 0,16 2.8,16 24,2.6",
    fill: "#FFFFFF"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 1.4,0 24,14.3 24,16 22.6,16 0,1.7",
    fill: "#C8102E"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "24,0 22.6,0 0,14.3 0,16 1.4,16 24,1.7",
    fill: "#C8102E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.6,
    width: 4.8,
    height: 16,
    fill: "#FFFFFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 5.6,
    width: 24,
    height: 4.8,
    fill: "#FFFFFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    width: 3.2,
    height: 16,
    fill: "#C8102E"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 6.4,
    width: 24,
    height: 3.2,
    fill: "#C8102E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.932d6aac3a236cb04fffc1d7d0b4ee45.svg";
export { ForwardRef as ReactComponent };